import { FC, LabelHTMLAttributes } from 'react'

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement>

export const Label: FC<LabelProps> = ({ children, ...rest }) => (
  <label className="flex flex-col font-semibold text-ink-800" {...rest}>
    {children}
  </label>
)
